import React, { useEffect } from "react";

import { useSelector } from "react-redux";
import { selectCurrentExamMLResult } from "store/ExamMLResultStore/selectors";
import Skeleton from "react-loading-skeleton";
import { selectRequests } from "store/LoadingStore/selectors";
import { Requests } from "types/requests";
import { useAppSelector } from "hooks/reduxHooks";
import { MotionCard } from "../components/MotionCard";

export const RangeOfMotion = () => {
  const examMLResult = useSelector(selectCurrentExamMLResult);
  const loading = useAppSelector((state) =>
    selectRequests([Requests.getMinMaxFrames], state)
  );

  const getAlert = () => {
    const itemStr = localStorage.getItem("trimmed-video");

    if (!itemStr) {
      return null;
    }

    try {
      const item = JSON.parse(itemStr);
      const now = new Date();

      if (
        now.getTime() > item.expiry ||
        !window.location.href.includes(item.examId)
      ) {
        localStorage.removeItem("trimmed-video");
        return null;
      }

      return (
        <div
          className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 my-2"
          role="alert"
        >
          <p>The results might take a couple of minutes to be updated.</p>
        </div>
      );
    } catch (e) {
      localStorage.removeItem("trimmed-video");
      return null;
    }
  };

  return (
    <article>
      {loading || Object.keys(examMLResult).length === 0 ? (
        <div className="w-[168px] h-24">
          <Skeleton />
          <div className="flex w-full flex-wrap items-center space-x-2 mt-4">
            <div className="w-[68px] h-[50px]">
              <Skeleton height={50} />
            </div>
            <div className="w-[68px] h-[50px]">
              <Skeleton height={50} />
            </div>
          </div>
        </div>
      ) : (
        <>
          <h3>Range of Motion </h3>
          {getAlert()}
          <div className="flex flex-wrap items-center space-x-2 mt-4">
            {examMLResult.side == "both" ? (
              <>
                <MotionCard
                  title="Left"
                  value={examMLResult?.result.leftMinValue}
                  image={examMLResult?.result.leftMinImg}
                />
                <MotionCard
                  title="Right"
                  value={examMLResult?.result.rightMinValue}
                  image={examMLResult?.result.rightMinImg}
                />
              </>
            ) : (
              <>
                <MotionCard
                  title="Min"
                  value={examMLResult?.result.minValue}
                  image={examMLResult?.result.minImg}
                />
                <MotionCard
                  title="Max"
                  value={examMLResult.result.maxValue}
                  image={examMLResult.result.maxImg}
                />
              </>
            )}
          </div>
        </>
      )}
    </article>
  );
};
